import axios from 'axios';
// import { window.API_BASE_URL } from '../config.js';
import Cookies from 'universal-cookie'

const initialState = {
    ReportList: [],
};

// Action Types
const GET_REPORT = 'GET_REPORT';

// Reducer
export default function integrationReducer(state = initialState, action) {
    switch (action.type) {
        case GET_REPORT:
            return { ...state, ReportList: action.payload }; // Update ReportList with new data
        default:
            return state;
    }
}

// Action Creators
export const GetReport = (reports) => ({
    type: GET_REPORT,
    payload: reports,
});

// API Integration Function
export const fetchReportsFromAPI = (fechaInicio, fechaFin) => async (dispatch) => {
    try {
        const cookies = new Cookies();
        const response = await axios.post(`${window.API_BASE_URL}/Integration/InjectionReport`,
            {
                startDate: fechaInicio, // se envían aunque backend aún no lo use
                endDate: fechaFin
            },
            {
                headers: { Authorization: `Bearer ${cookies.get('token')}` },
            });
        const data = await response.data;
        dispatch(GetReport(data));
    } catch (error) {
        console.error('Error fetching reports:', error);
    }
};

// Acción para descargar el reporte en Excel desde API
export const downloadExcelReport = (fechaInicio, fechaFin) => async () => {
    try {
        const cookies = new Cookies();
        const response = await axios.post(
            `${window.API_BASE_URL}/Integration/InjectionReportExcel`,
            {
                startDate: fechaInicio, // se envían aunque backend aún no lo use
                endDate: fechaFin
            },
            {
                headers: {
                    Authorization: `Bearer ${cookies.get('token')}`
                },
                responseType: 'blob' // importante para manejar archivo
            }
        );

        // Crear enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'InjectionReport.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();

    } catch (error) {
        console.error('Error descargando Excel:', error);
    }
};

